<div class="CmsMenu">

    <ul class="main-content">
        <template v-for=" entry in structure.entries">

            <li v-if="entry.menu_entry == 1" @click="onMenuClick">

                <router-link :to="'/cms/' + entry.path"  :style="'background-image:url(' + entry.icon + ');'">{{entry.title}}</router-link>
            </li>
        </template>
    </ul>
    
    <div style="flex:3;"></div>

    <ul class="meta-content">
        <template v-for=" entry in structure.entries">

            <li v-if="entry.menu_entry == 2"  @click="onMenuClick">

                <router-link :to="'/cms/' + entry.path">{{entry.title}}</router-link>
            </li>
        </template>
    </ul>

</div>
